import { sessionUrgencyMessages } from '@/components/ui/session-urgency/messages';
import { DropdownMenuItem } from '@heidi/design-system/dropdown-menu';
import { TypographyP2 } from '@heidi/design-system/typography';
import { Check, Flag } from 'lucide-react';
import { useIntl } from 'react-intl';
import { useUrgencyFilter } from './hooks/useUrgencyFilter';

/**
 * Flat "Urgent" toggle row for the session-list filter dropdown.
 * Toggles the boolean `is_urgent` filter in place (no sub-menu) and shows a
 * trailing check when active. Rendered in the neutral filter colour to match
 * its sibling filter rows (Status, Date range); the red urgency accent lives on
 * the row flag + active chip, not the filter-by entry.
 */
export const UrgencyFilterItem = () => {
  const intl = useIntl();
  const { isUrgentOnly, toggleUrgentOnly } = useUrgencyFilter();

  return (
    <DropdownMenuItem
      className="flex items-center gap-2"
      onSelect={(e) => e.preventDefault()}
      onClick={toggleUrgentOnly}
    >
      <Flag size={16} fill="currentColor" className="min-w-4" aria-hidden="true" />
      <TypographyP2 className="flex-1">
        {intl.formatMessage(sessionUrgencyMessages.urgent)}
      </TypographyP2>
      {isUrgentOnly && <Check className="ms-auto size-4" aria-hidden="true" />}
    </DropdownMenuItem>
  );
};
